import { render, staticRenderFns } from "./ShortQuestion.vue?vue&type=template&id=07cfd330&scoped=true&"
import script from "./ShortQuestion.vue?vue&type=script&lang=js&"
export * from "./ShortQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ShortQuestion.vue?vue&type=style&index=0&id=07cfd330&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfd330",
  null
  
)

export default component.exports